/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Details_Archived_AtInputs */

const fr_vehicle_details_archived_at = /** @type {(inputs: Vehicle_Details_Archived_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivé le`)
};

const en_vehicle_details_archived_at = /** @type {(inputs: Vehicle_Details_Archived_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived on`)
};

/**
* | output |
* | --- |
* | "Archived on" |
*
* @param {Vehicle_Details_Archived_AtInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_archived_at = /** @type {((inputs?: Vehicle_Details_Archived_AtInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_Archived_AtInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_archived_at(inputs)
	return en_vehicle_details_archived_at(inputs)
});